import React from 'react'
import styles from './TextInput.module.css';

interface TextInputProps {
  label?: string;
  value?: string | null;
  placeHolder?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  error?: string | null
}

const TextInput = ({ label, onChange, error, placeHolder, value }: TextInputProps) => {
  return (
    <div className={styles.inputWrapper}>
      {label && <label>{label}</label>}
      <div>
        <input
          className={styles.input}
          type='text'
          value={value || ""}
          placeholder={placeHolder || 'Enter Value'}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            onChange && onChange(event);
          }}
        />
        {error && <div className={styles.errorText}>{error}</div>}
      </div>
    </div>
  )
}

export default TextInput
